<div style="padding-top: 20px;" *ngIf="user && !print">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        <i class="fa fa-arrow-left" style="margin-right: 8px;"
            [routerLink]="['/dashboard/sales/customers']"></i>
        Details of {{user.name}}</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6 order-2 order-md-1">
          <div class="row">
            <div class="col-12 col-sm-4">
              <div class="info-box bg-light">
                <div class="info-box-content">
                  <span class="info-box-text text-center text-muted">Property ID</span>
                  <span class="info-box-number text-center text-muted mb-0">{{user.pid}}</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-4">
              <div class="info-box bg-light">
                <div class="info-box-content">
                  <span class="info-box-text text-center text-muted">Property Cost</span>
                  <span class="info-box-number text-center text-muted mb-0">{{user.property_cost |
                    currency:'INR'}}</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-4">
              <div class="info-box bg-light">
                <div class="info-box-content">
                  <span class="info-box-text text-center text-muted">Amount Recived</span>
                  <span class="info-box-number text-center text-muted mb-0">
                    {{user.property_cost - user.remaining_balance | currency:'INR'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12">
              <div class="info-box bg-light">
                <div class="info-box-content">
                  <span class="info-box-text text-center text-muted">Payment Plan</span>
                  <span class="info-box-number text-center text-muted mb-0" *ngIf="user.payment_plan === 'clp'">
                    {{user.payment_plan|uppercase}}[{{user.emi_ammount | currency:'INR'}}] |
                    {{user.emi_ammount/user.payment_tenure | currency:'INR'}}/month
                  </span>
                  <span class="info-box-number text-center text-muted mb-0" *ngIf="user.payment_plan === 'downpayment'">
                    {{user.payment_plan|uppercase}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="info-box bg-light">
                <div class="info-box-content">
                  <span class="info-box-text text-center text-muted">Payment Date</span>
                  <span class="info-box-number text-center text-muted mb-0" *ngIf="user.payment_plan === 'clp'">
                    {{user.payment_date}} of every month X {{user.payment_tenure}}
                  </span>
                  <span class="info-box-number text-center text-muted mb-0" *ngIf="user.payment_plan === 'downpayment'">

                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="info-box bg-light">
                <div class="info-box-content">
                  <span class="info-box-text text-center text-muted">Remaining Amount</span>
                  <span class="info-box-number text-center text-muted mb-0">{{user.remaining_balance |
                    currency:'INR'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 order-1 order-md-2">
          <h4 class="text-primary">
            <span><i class="fas fa-user" style="padding-right: 5px;"></i>{{user.name}}</span>
            <span class="float-right" style="font-size: 14px; cursor: pointer;" data-toggle="modal"
              data-target="#Customeredit">
              <i class="fa fa-edit"></i>edit
            </span>
          </h4>
          <br>
          <div class="text-muted">
            <div class="row">
              <div class="col-md-6">
                <p class="text-sm">Full Name
                  <b class="d-block">{{user.name}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">Phone Number
                  <b class="d-block"> {{user.contact_1}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">Alternate Number
                  <b class="d-block"> {{user.contact_2}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">Email
                  <b class="d-block">{{user.email}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">Aadhar Number
                  <b class="d-block"> {{user.aadhar_no}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">PAN Number
                  <b class="d-block"> {{user.pan_no}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">Occupation
                  <b class="d-block">{{user.job}}</b>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-sm">Address
                  <b class="d-block">{{user.address}}</b>
                </p>
              </div>
              <div class="col-md-12">
                <p class="text-sm">Remarks
                  <b class="d-block">{{user.notes}}</b>
                </p>
              </div>
            </div>

          </div>
        </div>

        <div class="col-md-12 order-1 order-md-2 pt-4">
          <h4 class="text-primary">
            <span><i class="fas fa-building" style="padding-right: 5px;"></i>Property Details</span>
          </h4>
          <br>
          <div class="text-muted">
            <div class="row">
              <div class="col-md-4">
                <p class="text-sm">Property ID
                  <b class="d-block">{{user.pid}}</b>
                </p>
              </div>
              <div class="col-md-4">
                <p class="text-sm">Property Type
                  <b class="d-block"> {{user.property.type}}</b>
                </p>
              </div>
              <div class="col-md-4">
                <p class="text-sm">Area
                  <b class="d-block"> {{user.property.carpet_area}}</b>
                </p>
              </div>
              <div class="col-md-4" *ngIf="user.property.type === 'plot'">
                <p class="text-sm">Dimensions
                  <b class="d-block">L: {{user.property.length}} x W: {{user.property.width}}</b>
                </p>
              </div>
              <div class="col-md-4">
                <p class="text-sm">Base Price
                  <b class="d-block"> {{user.base_price}}</b>
                </p>
              </div>
              <div class="col-md-4">
                <p class="text-sm">IFMS
                  <b class="d-block"> {{user.edc}}</b>
                </p>
              </div>
              <div class="col-md-4">
                <p class="text-sm">GST
                  <b class="d-block">{{user.gst}}%</b>
                </p>
              </div>
              <div class="col-md-4" *ngIf="user.inventory">
                <p class="text-sm">Inventory
                  <b class="d-block">{{user.inventory}} - ₹{{user.inventory_price}}</b>
                </p>
              </div>
              <div class="col-md-12">
                <p class="text-sm">PLC
                  <b class="d-block" *ngFor="let plc of user.plc">{{plc.plc_name}} - ₹{{plc.price}}</b>
                </p>
              </div>
            </div>

          </div>
        </div>

        <div class="col-md-12 order-1 order-md-2 pt-4">
          <h4 class="text-primary">
            <span><i class="fas fa-user" style="padding-right: 5px;"></i>Sales officer</span>
          </h4>
          <br>
          <div class="text-muted">
            <div class="row">
              <div class="col-md-3">
                <p class="text-sm">Sales Officer
                  <b class="d-block">{{user?.sale_person.name}}</b>
                </p>
              </div>
              <div class="col-md-3">
                <p class="text-sm">Source
                  <b class="d-block"> {{user.source}}</b>
                </p>
              </div>
              <div class="col-md-3" *ngIf="user.source === 'channel-partner'">
                <p class="text-sm">Channel Partner
                  <b class="d-block"> {{user.channel_partner?.name}}</b>
                </p>
                <div
                class="form-group" *ngIf="!user.channel_partner?.name">
                  <select class="form-control" #cp (change)="updateCp(cp)" [disabled]="cpFlag">
                    <option value="null" selected disabled>Select a channel partner</option>
                    <option [value]="cp._id" *ngFor="let cp of channelPartners">{{cp.name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3" *ngIf="user.sub_broker">
                <p class="text-sm">Sub Broker
                  <b class="d-block">{{user.sub_broker?.name}}</b>
                </p>
              </div>
            </div>

          </div>
        </div>


      </div>
      <div class="row pt-4">
        <div class="col-12">
          <div class="card card-tabs">
            <div class="card-header p-0 pt-1 border-bottom-0">
              <ul class="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill"
                    href="#custom-tabs-three-home" role="tab" aria-controls="custom-tabs-three-home"
                    aria-selected="true">Recent Payments</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill"
                    href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile"
                    aria-selected="false">EMI / Downpayment Lists</a>
                </li>
              </ul>
            </div>
            <div class="card-body" style="height: 400px; overflow: auto;">
              <div class="tab-content" id="custom-tabs-three-tabContent">
                <div class="tab-pane fade active show" id="custom-tabs-three-home" role="tabpanel"
                  aria-labelledby="custom-tabs-three-home-tab">
                  <div class="post" *ngFor="let payment of payments">
                    <div class="user-block">
                      <span class="username" style="margin-left:10px ;">
                        <a>₹{{payment.amount}}</a>
                      </span>
                      <span class="description" style="margin-left:10px ;">{{payment.date | date:'fullDate' }}</span>
                    </div>

                    <ul class="payment">
                      <li>
                        <span>Date: </span>{{payment.date | date:'fullDate' }}
                      </li>
                      <li>
                        <span>Mode: </span>{{payment.mode}}
                      </li>
                      <li>
                        <span>Ref no.: </span>{{payment.ref_number}}
                      </li>
                      <li>
                        <span>Type/Plan: </span>{{payment.plan}}
                      </li>
                      <li>
                        <span>Amount: </span> {{payment.amount | currency:'INR'}}
                      </li>
                    </ul>

                    <p class="ptools">
                      <a class="link-black text-sm mx-1" (click)="receipt(payment);"><i
                          class="fas fa-print mr-1"></i>receipt</a>
                      <a class="link-black text-sm mx-1" (click)="delete(payment.id);"
                        *ngIf="currentUser.role ==='admin' || currentUser.role ==='manager' || currentUser.role ==='account'">
                        <i class="fas fa-trash" style="margin-left: 5px"></i> delete</a>
                    </p>
                  </div>
                </div>
                <div class="tab-pane fade" id="custom-tabs-three-profile" role="tabpanel"
                  aria-labelledby="custom-tabs-three-profile-tab">
                  <div class="table-responsive">
                    <table class="table m-0">
                      <thead>
                        <tr>
                          <th>EMI Date</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th
                            *ngIf="currentUser.role ==='admin' || currentUser.role ==='manager' || currentUser.role ==='account'">
                            Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let emi of emis">
                          <td><a href="javascript:void(0)">{{emi.emi_date | date:'fullDate'}}</a></td>
                          <td>{{emi.emi_amount | currency:'INR':'symbol'}}</td>
                          <td>
                            <div class="sparkbar" data-color="#00a65a" data-height="20">{{emi.status}}</div>
                          </td>
                          <td
                            *ngIf="currentUser.role ==='admin' || currentUser.role ==='manager' || currentUser.role ==='account'">
                            <a class="btn btn-sm btn-success" style="margin-left: 10px ;" data-toggle="modal"
                              *ngIf="emi.status == 'due'" data-target="#paymentModal" (click)="addPayment(emi)">Add
                              payment</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Payment modal -->

<div class="modal fade" id="paymentModal" tabindex="-1" role="dialog" aria-labelledby="paymentModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="paymentModalTitle">Add a new payment details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="paymentForm" (ngSubmit)="onSubmit();">

          <div class="form-group">
            <label>Date:</label>
            <div class="input-group">
              <div class="input-group-prepend" (click)="dp.toggleCalendar()">
                <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
              </div>
              <input class="form-control" placeholder="Select a date" angular-mydatepicker name="date"
                (click)="dp.toggleCalendar()" autocomplete="off" formControlName="date" [options]="myOptions"
                #dp="angular-mydatepicker" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="plotNumber">Ref Number:</label>
              <input type="text" class="form-control" formControlName="ref_number">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Mode:</label>
              <select class="form-control" formControlName="mode">
                <option value="cash">CASH</option>
                <option value="cheque">CHEQUE</option>
                <option value="neft">NEFT</option>
                <option value="imps">IMPS</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label>Payment plan:</label>
              <select class="form-control" formControlName="plan">
                <option value="downpayment">Downpayment</option>
                <option value="clp">CLP</option>
                <!-- <option value="tokenamount">Token Amount</option> -->
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <label>Amount:</label>
              <input type="text" class="form-control" formControlName="amount">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" id="pclose-btn">Close</button>
            <button type="submit" value="submit" class="btn btn-primary" [disabled]="!paymentForm.valid">Add
              Payment</button>
          </div>

        </form>
      </div>


    </div>
  </div>
</div>


<!-- User edit modal -->

<div class="modal fade" id="Customeredit" tabindex="-1" role="dialog" aria-labelledby="CustomereditTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 60%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="CustomereditTitle">Edit Customer Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="customerForm" (ngSubmit)="onEdit();">

          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="name">Name:</label>
              <input type="text" class="form-control" formControlName="name">
            </div>

            <div class="form-group col-md-6">
              <label for="job">Occupation:</label>
              <input type="text" class="form-control" formControlName="job">
            </div>

            <div class="form-group col-md-3">
              <label for="contact_1">Contact:</label>
              <input type="text" class="form-control" formControlName="contact_1">
            </div>

            <div class="form-group col-md-3">
              <label for="contact_2">Alternate Contact:</label>
              <input type="text" class="form-control" formControlName="contact_2">
            </div>

            <div class="form-group col-md-6">
              <label for="email">Email:</label>
              <input type="text" class="form-control" formControlName="email">
            </div>

            <div class="form-group col-md-6">
              <label for="aadhar_no">AAdhar Number:</label>
              <input type="text" class="form-control" formControlName="aadhar_no">
            </div>

            <div class="form-group col-md-6">
              <label for="pan_no">PAN Number:</label>
              <input type="text" class="form-control" formControlName="pan_no">
            </div>

            <div class="form-group col-md-12">
              <label for="address">Address:</label>
              <textarea class="form-control"  formControlName="address"></textarea>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" id="editclose">Close</button>
            <button type="submit" value="submit" class="btn btn-primary" [disabled]="!customerForm.valid">save</button>
          </div>

        </form>
      </div>


    </div>
  </div>
</div>
<!-- reciept section  -->

<div style="padding-top: 20px;" *ngIf="print">
  <div class="card">
    <div class="card-header no-print">
      <button class="btn btn-secondary" (click)="back();">Back</button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="invoice p-3 mb-3" id="print-section">
            <div class="row">
              <div class="col-12">
                <h4>
                  <i class="fas fa-globe"></i> PropiFy
                  <small class="float-right">Date: {{payment.date | date:'fullDate' }}</small>
                </h4>
              </div>
            </div>
            <div class="row invoice-info">
              <div class="col-sm-4 invoice-col">
                From
                <address>
                  <strong>Admin, Inc.</strong><br>
                  795 Folsom Ave, Suite 600<br>
                  San Francisco, CA 94107<br>
                  Phone: (804) 123-5432<br>
                  Email: info@almasaeedstudio.com
                </address>
              </div>
              <div class="col-sm-4 invoice-col">
                To
                <address>
                  <strong>{{payment.customer.name}}</strong><br>
                  {{payment.customer.contact_1}}<br>
                  {{payment.customer.address}}
                </address>
              </div>
              <div class="col-sm-4 invoice-col">
                <b>Invoice #{{payment._id}}</b><br>
                <br>
                <b>Property ID:</b> {{payment.customer.pid}}<br>
                <b>Ref. no.:</b> {{payment.ref_number}}<br>
                <b>Amount:</b> {{payment.amount}}
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Property ID</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td> {{payment.customer.pid}}</td>
                      <td>{{payment.amount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <p class="lead">Remark:</p>
                <p class="text-muted well well-sm shadow-none" style="margin-top: 10px;">
                  Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem
                  plugg
                  dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra.
                </p>
              </div>
              <!-- <div class="col-6">
                <p class="lead">Amount Due 2/22/2014</p>

                <div class="table-responsive">
                  <table class="table">
                    <tbody><tr>
                      <th style="width:50%">Subtotal:</th>
                      <td>$250.30</td>
                    </tr>
                    <tr>
                      <th>Tax (9.3%)</th>
                      <td>$10.34</td>
                    </tr>
                    <tr>
                      <th>Shipping:</th>
                      <td>$5.80</td>
                    </tr>
                    <tr>
                      <th>Total:</th>
                      <td>$265.24</td>
                    </tr>
                  </tbody></table>
                </div>
              </div> -->
            </div>
            <div class="row no-print">
              <div class="col-12">
                <button onclick="window.print()" class="btn btn-default"><i class="fas fa-print"></i> Print</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
